import { FormGroup } from '@angular/forms';
import { GlobalConstants } from '../constants/global.constant';

export class IPOSValidator {
    static EMAIL = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    static PASSWORD = new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$');
    static PASSWORD_REGEX = GlobalConstants.PASSWORD_REGEX;
    static VERIFICATION_CODE = new RegExp('^[0-9]{1,6}$');
    static SPECIAL_CHARS = new RegExp(/[^a-zA-Z0-9_.\-@]/);
    static AVOID_CONSECUTIVE = new RegExp(/((?:^[^@]*@)[^@]*)@/g);
    static SYSTEMID_REGEX = new RegExp(/^[A-Z0-9_]+$/);
    static BATTERYLIFE_REGEX = new RegExp(/^[0-9\,\.]*$/); 
    // TODO stating return type should be ValidatorFn

     static confirmedValidator(controlName: string, matchingControlName: string) {
        return (formGroup: FormGroup) => {
            const control = formGroup.controls[controlName];
            const matchingControl = formGroup.controls[matchingControlName];
            if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
                return;
            }
            if (control.value !== matchingControl.value) {
                matchingControl.setErrors({ confirmedValidator: true });
            } else {
                matchingControl.setErrors(undefined);
            }
        };
    }

}
